import { posthog } from 'posthog-js';
import Button from '../buttons/baseButton';
import { FrontendFilterValue } from '../../types/filters.type';
import customIcons from '../../utils/icons';

interface CheckHouseholdsButtonProps {
  householdReferences: FrontendFilterValue[];
  startSnapshot: string;
  endSnapshot: string;
  getValidHouseholds: (references: FrontendFilterValue[]) => void;
}
export default function CheckHouseholdsButton({
  householdReferences,
  startSnapshot,
  endSnapshot,
  getValidHouseholds,
}: CheckHouseholdsButtonProps) {
  const hasRequiredInputs = householdReferences.length > 0
    && Boolean(startSnapshot)
    && Boolean(endSnapshot);

  if (!hasRequiredInputs) {
    return null;
  }

  const isCheckHouseholdsEnabled = posthog.getFeatureFlag('outcome-tracker-check-households')
    === 'test';

  if (!isCheckHouseholdsEnabled) {
    return null;
  }

  return (
    <Button
      id="check-households"
      label="Check Households"
      onClick={() => getValidHouseholds(householdReferences)}
      icon={customIcons.eyeSearch}
      className="ml-4 button-radio border border-pie-chart-slice2 text-secondary hover:bg-gray-100"
    />
  );
}
